module.exports = __webpack_public_path__ + "media/images/icon-physical-80c92f0927d394dd2c6dbe7d59e63968.png";